import React, { Fragment, useEffect, useState } from "react";
import authQueries from '../../../queries/authQueries';
import { usePaginationStore, userStore } from '../../../store/userStore';
import {  Empty, message, Popconfirm } from 'antd';
import { Badge, Collapse, Grid, Pagination, Text } from '@nextui-org/react';
import { decode } from 'html-entities';
import MasterHeader from "../../Common/MasterHeader";
import { yupResolver } from "@hookform/resolvers/yup";
import InputUseForm from "../../Common/InputUseForm";
import * as yup from 'yup'
import { useForm } from "react-hook-form";
import PaginationComponent from "../../Common/PaginationComponent";
import LoaderCommon from "../../Common/LoaderCommon";
import MasterModal from "../../Common/MasterModal";
import AutoCompleteInput from "../../Common/AutoCompleteInput";
import { generateValidationSchema } from "../../Common/validationSchema";

const ListDoc =()=>{

    const [result, setResult] = useState([])
    const [name, setName] = useState('')
    const [visa, setVisa] = useState([])
    const master = userStore();

    const currentPage = usePaginationStore((state) => state.currentPage);
    const setCurrentPage = usePaginationStore((state) => state.setCurrentPage);

    const documentList = authQueries.useDocDetailMutationList(
        (response) => {
            setResult(response)            
        }   
    );

    const visaListing = authQueries.useVisaTypeMutationList(
        (response) => {
            const data = response?.data
            if(response.message === "Success"){
                const arr = []
                data?.items?.map(item => {
                    const newData = {
                        name: item.description,
                        id: item.id
                    }
                    arr.push(newData)
                })
                setVisa(arr)
            }
        }   
    );

    useEffect(() => {
        visaListing.mutateAsync({size: 500000})
    }, []);

    const inputFields = [
        {
            name: "vid",
            placeholder: "Visa Type",
            label: "Visa Type",
            size: "6",
            type: AutoCompleteInput,
            required: true,
            options: visa,
            optionProps:{name: "name", name2: "", value: "id", value2: "", advanced: false}
        },
        {
            name: "document_name",
            label: "Document Name",
            size: "6",
            min: 2,
            max: 250,
            type: InputUseForm,
            required: true
        },
    ]
    
      
    const { register ,reset, handleSubmit, formState:{ errors }, control, getValues, setValue, clearErrors } = useForm({
        resolver: yupResolver(generateValidationSchema())
    })
  
    useEffect(()=>{
        documentList.mutateAsync({search: name, page:currentPage, size:25});
    },[name, currentPage])


    const deleteDoc = authQueries.useDocDetailMutationDelete(
        (response) => {
            documentList.mutateAsync({search: '', status: '', page:0, size:25});
            message.success("successfully deleted")
        }
    );
    
    const deleteMaster = (event, id) => {
        event.preventDefault();
        deleteDoc.mutateAsync(id)
    }

    const [visible, setVisible] = useState(false)

    const handleOpen =async(item)=>{
        console.log(item)
        if(!item){
            await master.setMaster(null)
            setVisible(true)
            return 
        }else{
            reset(item)
            await master.setMaster(item.id)
            setVisible(true)
        }
    }

    const handleClose =async()=>{
        const getvalue = getValues()
        for(const key in getvalue) {
            if (getvalue.hasOwnProperty(key)) {
              setValue(key, "")
            }
        }
        clearErrors()
        await new Promise(resolve => setVisible(false, resolve));
        master.setMaster(null)
    }

    const createMaster = authQueries.useDocDetailMutationAdd(
        (response) => {
            if(response?.message === "Error"){
                {response.error.map((error, index) => (
                    Object.values(error).map((errorMessage, innerIndex) => (
                        message.error(errorMessage)
                    ))
                ))}
                return
            }
            handleClose()
            if(response?.message=== "Success"){
                message.success("Successfully created document")
                documentList.mutateAsync({search: name, page:currentPage, size:25});
            }
        }   
    );
        
    const updateMaster = authQueries.useDocDetailMutationEdit(
        (response) => {
            if(response?.message === "Error"){
                {response.error.map((error, index) => (
                    Object.values(error).map((errorMessage, innerIndex) => (
                        message.error(errorMessage)
                    ))
                ))}
                return
            }
            handleClose()
            if(response?.message=== "Success"){
                message.success("Successfully updated document")
                documentList.mutateAsync({search: name, page:currentPage, size:25});
            }
        }   
    );

    
    return(
        <div>

            <MasterHeader handleOpen={handleOpen} header="Document" breadcrumb="Document Details" />			
            
            <div className="add_clients" style={{borderBottom:0}}>

                <div className="row">
                    <div className="col-md-6 appointments-hing-wrpr">
                        <i className="appointments-icon">
                            <img src={require("../../../assets/images/appointments-today-icon.png")} width="" height="" alt="" />
                        </i>
                        <h2><span>&nbsp;</span>Document Details</h2>	
                    </div>
                        
                    <div className="col-md-12">
                        <hr className="progress-hr" />
                    </div>
                </div>
                
                <div id="accordion" className="add_clients_accordion_form">
                    <div className="card" id="appointments_wrpr">
                        <div className="card-header">
                            Document Details						
                        </div>
                        <div id="appointment_any" className="collapse show" data-parent="#accordion">
                            <div className="card-body">
                                <div className="row ">
                                    <div className="col-md-12">
                                        <div className="table-list-search-wrpr">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    
                                                </div>
                                                <div className="col-md-6 text-right">
                                                    <div className="table-search-filter-wrpr">
                                                        <div className="table-search-wrpr">
                                                            <input style={{minWidth: '300px'}} onChange={(e)=>{setName(e.target.value)}} className="form-control form-control-sm" type="text" placeholder="Search Visa Type" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {documentList.isLoading ?
                                            <LoaderCommon />:
                                            <div>
                                                {result?.data?.totalItems > 0 ?
                                                <Grid.Container style={{display:'block'}} gap={2}>
                                                    <Grid>
                                                        <Collapse.Group shadow>
                                                        {
                                                            result?.data?.items?.map((item, index) =>(
                                                                <Collapse 
                                                                    key={index} 
                                                                    title={<Text h6>{item.description}</Text>}
                                                                    subtitle={<span style={{fontSize:'12px'}}>{item?.documents?.length} Documents</span>}
                                                                >
                                                                    <div className="table-wrpr">
                                                                        <div className="table-section">
                                                                            <div className="row">
                                                                                <div className="col-md-12">
                                                                                    <table className="table prospect-table">
                                                                                        <thead>
                                                                                            <tr>
                                                                                            <th width="50">#</th>
                                                                                            <th>Document Name</th>
                                                                                            <th width="100">&nbsp;</th>
                                                                                            </tr>
                                                                                        </thead>

                                                                                        {
                                                                                            item?.documents?.map((items, indexes) =>(

                                                                                            <tbody key={indexes} className="ui-sortable">
                                                                                                <tr className="ui-sortable-handle">
                                                                                                <th className="">{indexes + 1}</th>
                                                                                                <td>{decode(items.document_name)}</td>
                                                                                                <td className="action-icons flex gap-2 justify-end">
                                                                                                    <button onClick={()=>{handleOpen(items)}} className="btn-nextrow mb-0">Update</button>
                                                                                                    <Popconfirm
                                                                                                        placement="left"
                                                                                                        title="Are you sure to delete this document?"
                                                                                                        onConfirm={(event) => {deleteMaster(event, items.id)}}
                                                                                                        okText="Yes"
                                                                                                        cancelText="No"
                                                                                                    >
                                                                                                    <button className="btn-removerow mb-0">Delete</button>
                                                                                                    </Popconfirm>
                                                                                                </td>
                                                                                                </tr>

                                                                                            </tbody>

                                                                                        ))}
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Collapse>
                                                            ))
                                                        }
                                                        </Collapse.Group>
                                                        <PaginationComponent result={result} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                                                    </Grid>
                                                </Grid.Container>:
                                                <div style={{margin:"5%"}}>
                                                    <Empty description={<div className="font-poppins">No description found!</div>} />
                                                </div>
                                                }
                                            </div>
                                        }

                                        <MasterModal
                                        width="50%"
                                        header="Document"
                                        visible={visible} 
                                        handleClose={handleClose} 
                                        inputFields={inputFields} 
                                        reset={reset} 
                                        control={control}
                                        handleSubmit={handleSubmit} 
                                        register={register} 
                                        errors={errors} 
                                        getValues={master?.master}
                                        defaultValues={getValues()}
                                        create={createMaster}
                                        update={updateMaster}
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ListDoc